/* YOME theme — cart drawer (AJAX), EN/AR toggle */
(function () {
  "use strict";

  var AR = function(){ return document.documentElement.lang === "ar"; };

  /* ---------- Cart drawer open/close ---------- */
  function openCart(){
    document.body.classList.add("cart-open");
    var d = document.getElementById("cart-drawer");
    if (d) d.setAttribute("aria-hidden", "false");
  }
  function closeCart(){
    document.body.classList.remove("cart-open");
    var d = document.getElementById("cart-drawer");
    if (d) d.setAttribute("aria-hidden", "true");
  }

  /* ---------- Money ---------- */
function money(cents){var v=(cents/100).toFixed(3);return v+" KD"}

  /* ---------- Free-shipping progress ---------- */
  function renderShip(cart){
    var wrap = document.getElementById("cart-ship");
    if (!wrap) return;
    var threshold = window.YOME_FREESHIP || 0;
    if (!threshold || !cart.items.length){ wrap.hidden = true; return; }
    wrap.hidden = false;
    var msg = document.getElementById("cart-ship-msg");
    var fill = document.getElementById("cart-ship-fill");
    var remaining = threshold - cart.total_price;
    var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    if (remaining <= 0){
      msg.innerHTML = AR() ? "🎉 حصلت على الشحن المجاني!" : "🎉 You’ve unlocked free shipping!";
      wrap.classList.add("unlocked");
    } else {
      wrap.classList.remove("unlocked");
      msg.innerHTML = AR()
        ? "أضف <strong>" + money(remaining) + "</strong> للحصول على شحن مجاني"
        : "You’re <strong>" + money(remaining) + "</strong> away from free shipping";
    }
    fill.style.width = pct + "%";
  }

  /* ---------- One cart line ---------- */
  function itemLineHTML(it){
    var src = it.image || (it.featured_image && it.featured_image.url) || "";
    var img = src
      ? '<img src="' + src.replace(/(\.[^.?]+)(\?.*)?$/, "_160x$1") + '" alt="' + (it.product_title || it.title || "") + '">'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 7h12l1 14H5L6 7Z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>';
    var title = (it.product_title || it.title || "").replace(/^YOME\s+/, "").replace(/\s+—\s+Pocket Perfume$/, "");
    var sub = (it.variant_title && it.variant_title !== "Default Title") ? it.variant_title : "";
    var lp = (it.final_line_price != null) ? it.final_line_price : (it.line_price != null ? it.line_price : it.price * it.quantity);
    return '<div class="cart-item" data-key="' + it.key + '">' +
        '<a class="cart-thumb" href="' + (it.url || "#") + '">' + img + '</a>' +
        '<div class="cart-item-info">' +
          '<h4>' + title + '</h4>' +
          (sub ? '<div class="muted">' + sub + '</div>' : "") +
          '<div class="qty-row">' +
            '<button type="button" data-dec="' + it.key + '" aria-label="Decrease">−</button>' +
            '<span class="qty-val">' + it.quantity + '</span>' +
            '<button type="button" data-inc="' + it.key + '" aria-label="Increase">+</button>' +
            '<button type="button" class="line-remove" data-remove="' + it.key + '" aria-label="Remove">' +
              (AR() ? "إزالة" : "Remove") + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="line-price">' + money(lp) + '</div>' +
      '</div>';
  }

  /* Optimistic: show the just-added line(s) before /cart.js returns */
  function renderAdded(data){
    var box = document.getElementById("cart-items");
    if (!box) return;
    var items = data && data.items ? data.items : (data && data.key ? [data] : []);
    if (!items.length) return;
    var foot = document.getElementById("cart-foot");
    if (foot) foot.style.display = "";
    box.innerHTML = items.map(itemLineHTML).join("");
    document.body.classList.remove("cart-loading");
  }

  /* ---------- Render cart ---------- */
  function renderCart(cart){
    var box = document.getElementById("cart-items");
    var tot = document.getElementById("cart-total");
    var headCount = document.getElementById("cart-head-count");
    var cnt = document.querySelectorAll(".cart-count");
    if (!box) return;

    cnt.forEach(function(c){
      c.textContent = cart.item_count;
      c.style.display = cart.item_count ? "" : "none";
    });
    if (headCount) headCount.textContent = cart.item_count;
    if (tot) tot.textContent = money(cart.total_price);

    var foot = document.getElementById("cart-foot");

    if (!cart.items.length){
      box.innerHTML =
        '<div class="cart-empty">' +
          '<div class="cart-empty-ic">🛍️</div>' +
          '<p>' + (AR() ? "سلتك فارغة" : "Your cart is empty") + '</p>' +
          '<span>' + (AR() ? "جرّب المجموعة الكاملة — أربع مدن." : "Try the full Set — four cities.") + '</span>' +
          '<button type="button" class="btn btn-slate cart-empty-cta" id="cart-empty-shop">' +
            (AR() ? "تسوّق العطور" : "Shop the scents") + '</button>' +
        '</div>';
      if (foot) foot.style.display = "none";
      renderShip(cart);
      return;
    }
    if (foot) foot.style.display = "";

    box.innerHTML = cart.items.map(itemLineHTML).join("");

    renderShip(cart);
  }

  function refreshCart(){
    return fetch("/cart.js", { headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); return cart; });
  }

  function addToCart(id, qty, btn){
    if (btn) btn.classList.add("is-loading");
    openCart();                 // open instantly for snappy feedback
    document.body.classList.add("cart-loading");
    return fetch("/cart/add.js", {
      method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function(r){ return r.json(); })
      .then(function(data){ renderAdded(data); return refreshCart(); })
      .catch(function(){})
      .then(function(){
        if (btn) btn.classList.remove("is-loading");
        document.body.classList.remove("cart-loading");
      });
  }

  function changeQty(key, qty){
    return fetch("/cart/change.js", {
      method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); }).then(renderCart);
  }

  function qtyOf(key){
    var el = document.querySelector('.cart-item[data-key="' + key + '"] .qty-val');
    return el ? parseInt(el.textContent, 10) || 0 : 0;
  }

  /* ---------- Events ---------- */
  // Intercept the product form so Add to cart opens the drawer (no page jump)
  document.addEventListener("submit", function(e){
    var form = e.target.closest("form.pdp-buy, form[action*='/cart/add']");
      if (!form || form.hasAttribute("data-yrp-add")) return;
    e.preventDefault();
    var fd = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add("is-loading");
    openCart();                 // open instantly for snappy feedback
    document.body.classList.add("cart-loading");
    fetch("/cart/add.js", { method:"POST", headers:{ "Accept":"application/json" }, body: fd })
      .then(function(r){ return r.json(); })
      .then(function(data){ renderAdded(data); return refreshCart(); })
      .catch(function(){})
      .then(function(){
        if (btn) btn.classList.remove("is-loading");
        document.body.classList.remove("cart-loading");
      });
  });

  document.addEventListener("click", function(e){
    var add = e.target.closest("[data-add-id]");
    if (add){ e.preventDefault(); addToCart(add.getAttribute("data-add-id"), 1, add); return; }

    if (e.target.closest("#nav-open-btn")){ e.preventDefault(); document.body.classList.add("nav-open"); return; }
    if (e.target.closest("#nav-close-btn") || e.target.id === "nav-overlay" || e.target.closest(".mnav-link")){ document.body.classList.remove("nav-open"); }
    if (e.target.closest("#cart-open-btn")){ e.preventDefault(); openCart(); return; }
    if (e.target.closest("#cart-close-btn") || e.target.closest("#cart-continue") || e.target.id === "cart-overlay"){ closeCart(); return; }
    if (e.target.closest("#cart-empty-shop")){ closeCart(); window.location.href = "/collections/all"; return; }

    var inc = e.target.closest("[data-inc]");
    if (inc){ var k = inc.getAttribute("data-inc"); changeQty(k, qtyOf(k) + 1); return; }
    var dec = e.target.closest("[data-dec]");
    if (dec){ var kd = dec.getAttribute("data-dec"); changeQty(kd, Math.max(0, qtyOf(kd) - 1)); return; }
    var rm = e.target.closest("[data-remove]");
    if (rm){ changeQty(rm.getAttribute("data-remove"), 0); return; }
  });

  document.addEventListener("keydown", function(e){
    if (e.key === "Escape" && document.body.classList.contains("cart-open")) closeCart();
    if (e.key === "Escape") document.body.classList.remove("nav-open");
  });

  /* Language toggle is a native Shopify localization form (submits on its own). */

  /* ---------- Product carousels (drag + arrows) ---------- */
  function initCarousels(){
    document.querySelectorAll("[data-carousel]").forEach(function(car){
      var track = car.querySelector(".carousel-track");
      if (!track) return;
      var head = car.previousElementSibling; // .container with nav (same section)
      var section = car.closest("section") || document;
      var prev = section.querySelector("[data-car-prev]");
      var next = section.querySelector("[data-car-next]");
      var step = function(){
        var card = track.querySelector(".scent-card");
        return card ? card.getBoundingClientRect().width + 20 : 300;
      };
      var rtl = document.documentElement.dir === "rtl";
      if (next) next.addEventListener("click", function(){ track.scrollBy({ left: (rtl ? -1 : 1) * step() * 1.5, behavior:"smooth" }); });
      if (prev) prev.addEventListener("click", function(){ track.scrollBy({ left: (rtl ? 1 : -1) * step() * 1.5, behavior:"smooth" }); });

      // drag to scroll — only capture the pointer once a real drag starts,
      // otherwise a plain tap stays on the card link and navigates normally
      var down = false, startX = 0, startScroll = 0, moved = 0, captured = false, pid = null;
      track.addEventListener("pointerdown", function(e){
        if (e.pointerType === "mouse" && e.button !== 0) return;
        down = true; moved = 0; captured = false; pid = e.pointerId;
        startX = e.clientX; startScroll = track.scrollLeft;
      });
      track.addEventListener("pointermove", function(e){
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4){
          moved += Math.abs(dx);
          if (!captured){ captured = true; track.classList.add("dragging"); try { track.setPointerCapture(pid); } catch(_){} }
        }
        if (captured) track.scrollLeft = startScroll - dx;
      });
      function end(){
        down = false;
        if (captured && pid != null){ try { track.releasePointerCapture(pid); } catch(_){} }
        captured = false; pid = null;
        setTimeout(function(){ track.classList.remove("dragging"); }, 30);
      }
      track.addEventListener("pointerup", end);
      track.addEventListener("pointercancel", end);
      track.addEventListener("pointerleave", end);
      // block click after a real drag
      track.addEventListener("click", function(e){ if (moved > 6){ e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(){
    var hero = document.querySelector("[data-hero]");
    if (!hero) return;
    var slides = hero.querySelectorAll(".hero-slide");
    var dots = hero.querySelectorAll(".hero-dots button");
    if (slides.length < 2){ var d = hero.querySelector(".hero-dots"); if (d) d.style.display = "none"; return; }
    var i = 0, timer;
    function go(n){
      i = (n + slides.length) % slides.length;
      slides.forEach(function(s,x){ s.classList.toggle("is-active", x === i); });
      dots.forEach(function(d,x){ d.classList.toggle("is-active", x === i); });
      var accent = slides[i].getAttribute("data-accent");
      var text = slides[i].getAttribute("data-text") || "#fff";
      if (accent){ hero.style.setProperty("--hero-accent", accent); hero.style.setProperty("--hero-accent-text", text); }
    }
    function start(){ timer = setInterval(function(){ go(i+1); }, 5500); }
    function reset(){ clearInterval(timer); start(); }
    dots.forEach(function(d){ d.addEventListener("click", function(){ go(+d.getAttribute("data-dot")); reset(); }); });
    start();
  }

  document.addEventListener("DOMContentLoaded", function(){ refreshCart(); initCarousels(); initHero(); });
})();
